import request from '../../config/axiosConfig';
import { CREATE_MINIAPP, DELETE_MINIAPP, GET_LIST_MINIAPPS, GET_MINIAPP_INFO, UPDATE_MINIAPP } from '../../constants/apiEndPoint';

export const getListMiniAppsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_MINIAPPS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getMiniAppInfoRequest = async (data) => {
  const result = await request({
    url: GET_MINIAPP_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createMiniAppRequest = async (data) => {
  const result = await request({
    url: CREATE_MINIAPP,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateMiniAppRequest = async (data) => {
  const result = await request({
    url: UPDATE_MINIAPP,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteMiniAppRequest = async (data) => {
    const result = await request({
      url: DELETE_MINIAPP,
      method: 'POST',
      data,
    });
    return result?.data;
  };
